export class MemoDocsView {
    public document: number;
    public agent: number;
    public amount: number;
    public vat: string;
    public currency: string;

    constructor(document, agent, amount, vat, currency) {
      this.document = document;
      this.agent = agent;
      this.amount = amount;
      this.vat = vat;
      this.currency = currency;
    }
}
